// Dashboard-related icons will be moved here by the user
// Examples: DashboardIcon, AppointmentsIcon, CoursesIcon, InvoicesIcon, ServicesIcon, CustomersAndPetsIcon, etc.

import { cn } from '@ui/lib/utils';
import { FC, SVGProps } from 'react';

export const CoursesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.466 9.343l-1.048-.622-9.43-5.653h-.115a1.052 1.052 0 00-.2-.068h-.388a1.16 1.16 0 00-.209.068h-.115L1.531 8.72a1.091 1.091 0 00-.389.415 1.2 1.2 0 000 1.138c.094.173.228.316.39.414l2.608 1.56v5.36c0 .9.331 1.762.92 2.398.59.637 1.39.994 2.223.994h8.383c.833 0 1.633-.357 2.222-.994.59-.636.92-1.498.92-2.398v-5.36l2.096-1.266v3.234c0 .3.11.588.307.8.197.212.463.33.741.33.278 0 .544-.118.741-.33.197-.212.307-.5.307-.8v-3.89c0-.2-.05-.396-.144-.57a1.09 1.09 0 00-.39-.413zm-5.753 8.265c0 .3-.11.587-.306.8a1.01 1.01 0 01-.741.33H7.283a1.01 1.01 0 01-.74-.33 1.177 1.177 0 01-.307-.8v-4.104l4.725 2.826.157.068h.095a.973.973 0 00.262 0 .974.974 0 00.261 0h.095a.472.472 0 00.157-.068l4.725-2.826v4.104zm-5.239-3.55L4.204 9.693l7.272-4.364 7.271 4.364-7.271 4.365z"
    ></path>
  </svg>
);

export const CustomersAndPetsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.36 14.23a3.76 3.76 0 01-4.72 0 1.001 1.001 0 00-1.28 1.54 5.68 5.68 0 007.28 0 1.001 1.001 0 00-1.28-1.54zM12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"
    ></path>
    <circle cx="9.5" cy="9.5" r="1.5" fill="currentColor"></circle>
    <circle cx="14.5" cy="9.5" r="1.5" fill="currentColor"></circle>
  </svg>
);

export const DashboardIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="curentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4691_4134)">
      <path
        fill="currentColor"
        d="M12 2C6.483 2 2 6.483 2 12s4.483 10 10 10 10-4.483 10-10S17.517 2 12 2zM5.95 6.292l.808.808a.818.818 0 00.592.242.83.83 0 00.592-1.417L7.217 5.2a8.204 8.204 0 013.958-1.483v.791c0 .459.375.834.833.834a.836.836 0 00.834-.834v-.791A8.299 8.299 0 0117 5.35l-.583.583a.83.83 0 00.591 1.417.854.854 0 00.592-.242l.633-.633a8.34 8.34 0 012.075 4.692h-.791a.836.836 0 00-.834.833c0 .458.375.833.834.833h.791a8.39 8.39 0 01-1.341 3.759c-1.017-.792-3.092-1.959-6.425-2.075l1.416-3.9a.831.831 0 00-.5-1.067.831.831 0 00-1.066.5l-1.642 4.508c-2.9.25-4.742 1.3-5.683 2.034a8.257 8.257 0 01-1.342-3.759h.792A.836.836 0 005.35 12a.836.836 0 00-.833-.833h-.792a8.326 8.326 0 012.233-4.875H5.95zM12 20.333c-2.3 0-4.392-.941-5.9-2.45.842-.65 2.708-1.716 5.9-1.716s5.058 1.066 5.9 1.708a8.307 8.307 0 01-5.9 2.458z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4691_4134">
        <path fill="#fff" d="M0 0H20V20H0z" transform="translate(2 2)"></path>
      </clipPath>
    </defs>
  </svg>
);

export const InvoicesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#fff"
      d="M3 3.5v16L5 21l15.5-.5-.5-7h-3l-1-10-3 2L12 4H9L6.5 5 3 3.5z"
    ></path>
    <path
      fill="currentColor"
      d="M13 16H7a1 1 0 100 2h6a1 1 0 000-2zm-4-6h2a1 1 0 000-2H9a1 1 0 000 2zm12 2h-3V3a1 1 0 00-1.5-.87l-3 1.72-3-1.72a1 1 0 00-1 0l-3 1.72-3-1.72A1 1 0 002 3v16a3 3 0 003 3h14a3 3 0 003-3v-6a1 1 0 00-1-1zM5 20a1 1 0 01-1-1V4.73l2 1.14a1.08 1.08 0 001 0l3-1.72 3 1.72a1.08 1.08 0 001 0l2-1.14V19a3 3 0 00.18 1H5zm15-1a1 1 0 11-2 0v-5h2v5zm-7-7H7a1 1 0 100 2h6a1 1 0 000-2z"
    ></path>
  </svg>
);

export const ServicesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 20.5a1 1 0 01-1-1v-15a1 1 0 011-1h6.38a1 1 0 01.9.55l.61 1.228a.4.4 0 00.358.222H18.5a1 1 0 011 1v8a1 1 0 01-1 1h-5.39a1 1 0 01-.89-.55l-.61-1.228a.4.4 0 00-.358-.222H6.9a.4.4 0 00-.4.4v5.6a1 1 0 01-1 1zm1.4-15a.4.4 0 00-.4.4v5.2c0 .221.18.4.4.4h5.353a.4.4 0 01.358.221l.778 1.558a.4.4 0 00.358.221H17.1a.4.4 0 00.4-.4V7.9a.4.4 0 00-.4-.4h-4.353a.4.4 0 01-.358-.221l-.778-1.558a.4.4 0 00-.358-.221H6.9z"
    ></path>
  </svg>
);

export const TeamMembersIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.3 12.22A4.92 4.92 0 0014 8.5a5 5 0 00-10 0 4.92 4.92 0 001.7 3.72A8 8 0 001 19.5a1 1 0 102 0 6 6 0 1112 0 1 1 0 002 0 8 8 0 00-4.7-7.28zM9 11.5a3 3 0 110-6 3 3 0 010 6zm9.74.32A5 5 0 0015 3.5a1 1 0 100 2 3 3 0 013 3 3 3 0 01-1.5 2.59 1 1 0 00-.05 1.7l.39.26.13.07a7 7 0 014 6.38 1 1 0 002 0 9 9 0 00-4.23-7.68z"
    ></path>
  </svg>
);

/* Filters Icon */
export const FiltersIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="white"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 8h12m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0m-6 8h12M9 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);

export const TutorialsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.17 2.06A13.099 13.099 0 0019 1.87a12.94 12.94 0 00-7 2.05 12.94 12.94 0 00-7-2 13.1 13.1 0 00-2.17.19 1 1 0 00-.83 1v12a1 1 0 001.17 1 10.9 10.9 0 018.25 1.91l.12.07h.11a.91.91 0 00.7 0h.11l.12-.07A10.9 10.9 0 0120.83 16 1.001 1.001 0 0022 15V3a1 1 0 00-.83-.94zM11 15.35a12.87 12.87 0 00-6-1.48H4v-10c.333-.02.667-.02 1 0a10.86 10.86 0 016 1.8v9.68zm9-1.44h-1a12.87 12.87 0 00-6 1.48V5.67a10.86 10.86 0 016-1.8c.333-.02.667-.02 1 0v10.04zm1.17 4.15a13.109 13.109 0 00-2.17-.19 12.94 12.94 0 00-7 2.05 12.94 12.94 0 00-7-2.05 13.11 13.11 0 00-2.17.19A1.002 1.002 0 002 19.21a1 1 0 001.17.79 10.903 10.903 0 018.25 1.91 1 1 0 001.16 0A10.904 10.904 0 0120.83 20a1 1 0 001.17-.79 1 1 0 00-.83-1.15z"
    ></path>
  </svg>
);
